// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { GoogleAuthProvider } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCepWiRBdiI4dDkpK8SWgEZOlgkTeD4Ag8",
  authDomain: "ai-entertainment.firebaseapp.com",
  projectId: "ai-entertainment",
  storageBucket: "ai-entertainment.appspot.com",
  messagingSenderId: "324637839807",
  appId: "1:324637839807:web:1084e3f1e2bdd55307910a",
  measurementId: "G-XM8GS34FK4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore();
export const provider = new GoogleAuthProvider();
